import { ExpandMoreOutlined } from '@mui/icons-material'
import { Box, Drawer, List, ListItem, Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useThemeMode } from '../../../theme'

const DrawerRow = ({ item, index, palette, t }) => {
  const background = index % 2 === 0 ? palette.paperColorDim : palette.paperColorDim2

  return (
    <ListItem sx={{ background, borderLeft: `4px solid ${palette.headerTransparentThinColor}`, alignItems: 'flex-start', flexDirection: 'column', gap: '2px', py: '10px' }}>
      <Typography fontSize='0.75rem' fontWeight={700} color={palette.headerColor}>
        {t('convention-announcement')}
      </Typography>
      <Typography fontSize='0.85rem' color={palette.textColor}>
        {item.text}
      </Typography>
    </ListItem>
  )
}

export const HotNewsHeaderAction = () => {
  const { palette } = useThemeMode()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', color: palette.paperColor, pointerEvents: 'none' }}>
      <Typography sx={{ fontSize: '0.8rem', fontWeight: 600 }}>
        show
      </Typography>
      <ExpandMoreOutlined fontSize="small" />
    </Box>
  )
}

export const HotNewsDrawer = ({ open, onClose }) => {
  const { palette } = useThemeMode()
  const { t, i18n } = useTranslation()
  const language = i18n.language

  const coninfoMessages = useSelector((state) => state?.coninfoMessages?.data)

  const announcementItems = useMemo(() => {
    const messages = (coninfoMessages ?? [])
      .filter((m) => m?.language === language)
      .flatMap((m) => m?.text ?? [])
      .filter(Boolean)
    return messages.map((text) => ({ type: 'announcement', text }))
  }, [coninfoMessages, language])

  return (
    <Drawer
      anchor="top"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { maxHeight: '60vh', borderRadius: '0 0 12px 12px', background: palette.paperColor }
      }}
    >
      <List disablePadding sx={{ overflowY: 'auto' }}>
        {announcementItems.map((item, index) => (
          <DrawerRow key={index} item={item} index={index} palette={palette} t={t} />
        ))}
      </List>
      <Box sx={{ width: '100%', height: '4px', background: palette.paperColorDivider, borderRadius: '2px', margin: '8px auto', maxWidth: '40px' }} />
    </Drawer>
  )
}
